import * as React from 'react'
import './flokkar-vorumerki.css'

export default class FlokkarVorumerki extends React.Component<any> {
  constructor(props: any) {
    super(props)
    this.state = {}
  }

  render() {
    const content = this.props.content
    return (
      <div className="flokkar-vorumerki-container">
        <div className="flokkar-vorumerki-sub-container item-container">
          {content !== undefined &&
            Object.keys(
              content.sort((a: any, b: any) =>
                a.fields.order > b.fields.order
                  ? 1
                  : b.fields.order > a.fields.order
                  ? -1
                  : 0,
              ),
            ).map(key => {
              return (
                <div key={key} className="flokkar-vorumerki">
                  <a href={content[key].fields.url} target="_blank">
                    <img src={content[key].fields.image.fields.file.url} />
                  </a>
                </div>
              )
            })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Product-page/flokkar-vorumerki/flokkar-vorumerki.tsx